import Swiper from 'swiper';
import viewport from "./viewport";

export default function() {

    function itemTileSldier() {

        let itemPicsSliders = document.getElementsByClassName('js-item-tile-slider');

        Array.from(itemPicsSliders).forEach(function (slider) {

            let picSwiper = new Swiper(slider, {
                loop: false,
                effect: 'fade',
                simulateTouch: false,
                followFinger: false,
                allowTouchMove: false,
                speed: 600,
                slidesPerView: 1,
                fadeEffect: {crossFade: true},
                navigation: {
                    nextEl: slider.parentElement.getElementsByClassName('item-tile-slider__arrow--next')[0],
                    prevEl: slider.parentElement.getElementsByClassName('item-tile-slider__arrow--prev')[0]
                },
            });
        });
    }

    itemTileSldier();
}